import { BaseEntityService } from 'src/app/shared';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { share, distinctUntilChanged, map } from 'rxjs/operators';
import { InstanceMonitoringData, InstanceMonitoringDataFactory } from '../models/instance-monitoring-data';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import Response = ZoningAPI.Response;
import * as _ from 'lodash';
import { Instance } from '../models/instance';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class InstanceMonitoringService extends BaseEntityService<InstanceMonitoringData> {
    private readonly instanceMonitoringDataSubject = new BehaviorSubject<InstanceMonitoringData>(null);

    readonly instanceMonitoringData = this.instanceMonitoringDataSubject
        .asObservable()
        .pipe(share(), distinctUntilChanged());

    constructor(private readonly http: HttpClient) {
        super(InstanceMonitoringDataFactory);
    }

    getInstanceMonitoringData(instance: Instance): Observable<InstanceMonitoringData> {
        if (!_.get(instance, 'Id')) {
            return of(null);
        }
        return this.http
            .get<Response>(environment.ZONAR_API_URL + `/instance/${instance.Id}/monitoring`)
            .pipe(map(response => this.initEntity(response.data)));
    }

    fixUnsynchronizedCRGroupIds(instanceId: number) {
        if (!instanceId) {
            return of(null);
        }
        return this.http
            .patch<Response>(environment.ZONAR_API_URL + `/instance/${instanceId}/fix/unsynchronized-cr-group-ids`, {})
            .pipe(map(response => this.getData(response)));
    }

    runOptimization(instanceId: number) {
        if (!instanceId) {
            return of(null);
        }
        return this.http
            .patch<Response>(environment.ZONAR_API_URL + `/instance/${instanceId}/fix/optimize`, {})
            .pipe(map(response => this.getData(response)));
    }
}
